const COURSE = 1;
const COMMUNITY = 2;
const MODEL = 3;

const COURSE_SINGULAR = 'course';
const COURSE_PLURAL = 'courses';

const MODEL_SINGULAR = 'model';
const MODEL_PLURAL = 'models';

const COMMUNITY_SINGULAR = 'community';
const COMMUNITY_PLURAL = 'communities';

const getName = (academicMainTypeId, plural = true) => {
  switch (academicMainTypeId) {
    case COMMUNITY:
      return plural ? COMMUNITY_PLURAL : COMMUNITY_SINGULAR;
    case MODEL:
      return plural ? MODEL_PLURAL : MODEL_SINGULAR;
    default:
      return plural ? COURSE_PLURAL : COURSE_SINGULAR;
  }
};

const getAcademicMainTypeIdFromName = (academicMainTypeName) => {
  return {
    [COURSE_PLURAL]      : COURSE,
    [COURSE_SINGULAR]    : COURSE,
    [MODEL_PLURAL]       : MODEL,
    [MODEL_SINGULAR]     : MODEL,
    [COMMUNITY_PLURAL]   : COMMUNITY,
    [COMMUNITY_SINGULAR] : COMMUNITY
  }[academicMainTypeName];
};

export default {
  COURSE, COMMUNITY, MODEL, getName, getAcademicMainTypeIdFromName
};
